import {AbstractModel} from "./abstract-model";

export class Country extends AbstractModel {
  isoCode: string | null = null;
  name: string | null = null;

  override toString(): string {
    return this.name ?? '';
  }
}
